import { render } from "./FinalPricingDetails.vue?vue&type=template&id=1e06960e&scoped=true"
import script from "./FinalPricingDetails.vue?vue&type=script&lang=js"
export * from "./FinalPricingDetails.vue?vue&type=script&lang=js"

import "./FinalPricingDetails.vue?vue&type=style&index=0&id=1e06960e&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e06960e"]])

export default __exports__